<template>
  <div class="card card-plain">
    <div class="card-body text-center p-0 px-4">
      <p>Opravdu chceš hrát hru {{ gameDetail.GameName }}?</p>
      <p>(bude odečteno <span class="text-primary text-bold">{{ formatNumber(gameDetail.GameCredit) }}</span> — nejdřív bonus, zbytek z kreditu)</p>
    </div>
    <div class="card-footer text-end border-top p-3">
      <argon-button
        class="text-sm me-2"
        :disabled="submitting"
        @click="addUserToGame"
        color="primary"
        size="md">
        Ano
      </argon-button>
      <argon-button
        class="text-sm" 
        @click="store.dispatch('closeModal')" 
        color="primary" 
        variant="outline" 
        size="md">
        Ne
      </argon-button>
    </div>
  </div>
</template>

<script setup>
import { computed, inject, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import dataService from "@/services/dataService.js";
import ArgonButton from "@/components/ArgonButton.vue";

const store = useStore();
const router = useRouter();
const swal = inject('$swal');

const openGame = computed(() => store.state.OpenGame);
const gameDetail = computed(() => store.state.GameDetail);
const userID = computed(() => store.getters.getUser.UserID);
const sessionHash = computed(() => store.getters.isLoggedIn);
const submitting = ref(false);

const addUserToGame = async () => {
  if (submitting.value) return;
  submitting.value = true;
  const response = await dataService.AddUserToGame(gameDetail.value.GameID, userID.value, sessionHash.value);

    if (response.Result) {
      store.commit('GAMES_REFRESH');
      removeOpenGame();
    }

  // Close modal
  store.dispatch('closeModal'); 

  // Show SweetAlert2
  swal.fire({
    position: 'center',
    icon: response.Result ? 'success' : 'error',
    html: response.Result ? 
      `<h5>${response.InfoMessage[0]}</h5>` + `<p>${response.InfoMessage[1]}</p>` : 
      `${response.ErrorMessage.map(message => `<h5>${message}</h5>`).join('')}`,
    showConfirmButton: false,
    timer: 3000,
    willClose: () => {
      // Redirect to profile if the action indicates so
      if (!response.Result && response.Action === 'PROFILE') {
        router.push('/profil');
      }
    }
  });
}

const removeOpenGame = () => {
  const bool = openGame.value.some(i => i.GameID === gameDetail.value.GameID);

  if (bool) {
    const index = openGame.value.findIndex(el => el.GameID === gameDetail.value.GameID);
    openGame.value.splice(index, 1);
  }
}

const formatNumber = (number) => { 
  return store.getters.formatNumber(number); 
};

</script>